<!--FavoritesSvg.vue-->
<template>
  <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-6 w-6"
      viewBox="0 0 24 24"
      fill="currentColor"
      :class="is_favorite ? 'text-red-500' : ''"
  >
    <path
        v-if="is_favorite"
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42
         4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81
         14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4
         6.86-8.55 11.54L12 21.35z"
    />
    <path
        v-else
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5
         2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09
         C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5
         c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    is_favorite: {
      type: Boolean,
      default: false
    },
  },
};
</script>